import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Daundtogrishneshwarbusonrent() {



  const cardData =
  {
    keyword: 'Daund to Grishneshwar Bus On Rent',
    heading: 'Sanavi Travels: Daund to Grishneshwar Bus On Rent',
    headingDescription: 'Sanavi Travels offers reliable Daund to Grishneshwar Bus On Rent, providing safe, comfortable, and convenient transportation for pilgrims, families, groups, and corporate travelers visiting the holy Grishneshwar temple. Our fleet of well-maintained AC and non-AC buses ensures spacious seating, smooth rides, and ample luggage space for a hassle-free journey. With professional drivers, flexible one-way and round-trip rental packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free travel. We provide convenient pickup and drop services across Daund, Pune, and nearby areas, making it ideal for religious trips, group travel, family outings, and corporate tours. Choose Sanavi Travels for trusted Daund to Grishneshwar bus rental services, delivering comfort, safety, and a seamless travel experience for every occasion.',

    top: 'Top Places to Visit in Grishneshwar with Sanavi Travels',


"topPlaces": [
  {
    "title": "Grishneshwar Temple",
    "description": "Grishneshwar Temple is one of the 12 Jyotirlingas of Lord Shiva, located near Ellora in Maharashtra. The temple’s intricate architecture, spiritual significance, and serene atmosphere make it a must-visit pilgrimage site."
  },
  {
    "title": "Ellora Caves",
    "description": "The UNESCO World Heritage Ellora Caves are located near Grishneshwar Temple. These rock-cut caves showcase ancient Buddhist, Hindu, and Jain art and architecture, making it a major cultural and historical attraction."
  },
  {
    "title": "Jata Shankar Caves",
    "description": "The Jata Shankar Caves, close to Grishneshwar, are associated with Lord Shiva and feature natural rock formations resembling Shiva’s matted hair. Pilgrims visit here for meditation and spiritual reflection."
  },
  {
    "title": "Daulatabad Fort",
    "description": "Daulatabad Fort, situated near Grishneshwar, is a historic fortification known for its strategic architecture, massive gates, and steep incline. It provides panoramic views and a glimpse into medieval Indian history."
  },
  {
    "title": "Aurangabad Bibi Ka Maqbara",
    "description": "Located a short drive from Grishneshwar, Bibi Ka Maqbara is often called the 'Mini Taj Mahal.' This architectural marvel attracts tourists for its Mughal-inspired beauty and serene gardens."
  },
  {
    "title": "Ellora Waterfalls",
    "description": "Ellora Waterfalls, found nearby, offer a peaceful natural retreat. Visitors can enjoy the scenic beauty, take short treks, and experience nature’s tranquility in the vicinity of the temple."
  },
  {
    "title": "Grishneshwar Temple Gardens",
    "description": "The temple complex is surrounded by well-maintained gardens that provide a serene environment for reflection, meditation, and peaceful walks after darshan."
  },
  {
    "title": "Local Handicraft Markets",
    "description": "Markets around Grishneshwar and Ellora sell local handicrafts, religious items, and souvenirs. They provide visitors with cultural insights and the chance to take home mementos."
  },
  {
    "title": "Aurangabad City Attractions",
    "description": "Nearby Aurangabad offers additional historical and cultural sites such as Panchakki, Siddharth Garden, and heritage walks, allowing visitors to explore the region further."
  },
  {
    "title": "River and Natural Surroundings",
    "description": "The area around Grishneshwar Temple is enriched with natural landscapes, small rivers, and greenery, creating a peaceful setting that complements the spiritual experience."
  }
]
,



"services": [
    {
      "name": "Daund to Grishneshwar Bus On Rent",
      "description": "Daund to Grishneshwar Bus On Rent provides comfortable and reliable transportation for pilgrims, families, and groups traveling from Daund to the holy Grishneshwar Jyotirlinga temple. Spacious buses, professional drivers, and timely service ensure a safe and smooth journey."
    },
    {
      "name": "Grishneshwar Jyotirlinga Bus",
      "description": "Grishneshwar Jyotirlinga Bus offers dedicated transportation for devotees visiting Grishneshwar. With well-maintained buses, comfortable seating, and experienced drivers, it ensures a convenient and memorable pilgrimage experience."
    },
    {
      "name": "AC Bus Daund to Grishneshwar",
      "description": "AC Bus Daund to Grishneshwar provides air-conditioned buses for a refreshing and comfortable journey. Ideal for long-distance religious trips, family travel, and group tours, combining safety, convenience, and reliability."
    },
    {
      "name": "Religious Bus Tour Daund",
      "description": "Religious Bus Tour Daund caters to pilgrims and spiritual travelers visiting Grishneshwar and other nearby temples. With organized itineraries, safe buses, and professional chauffeurs, it ensures a peaceful and hassle-free journey."
    },
    {
      "name": "Family Bus Grishneshwar",
      "description": "Family Bus Grishneshwar is designed for families traveling to Grishneshwar from Daund. Spacious seating, entertainment options, and experienced drivers make the journey comfortable, safe, and enjoyable for all family members."
    },
    {
      "name": "Group Travel Bus Grishneshwar",
      "description": "Group Travel Bus Grishneshwar offers organized transportation for corporate groups, friends, and social gatherings. Comfortable buses and professional drivers ensure smooth and convenient travel for groups of all sizes."
    },
    {
      "name": "Affordable Bus Grishneshwar",
      "description": "Affordable Bus Grishneshwar provides budget-friendly bus rental solutions without compromising on safety or comfort. Perfect for family trips, group pilgrimages, and religious tours from Daund."
    },
    {
      "name": "Chauffeur Driven Bus Grishneshwar",
      "description": "Chauffeur Driven Bus Grishneshwar delivers a stress-free travel experience with professional drivers handling navigation, traffic, and schedules. Ideal for pilgrims, families, and groups seeking reliable transportation."
    },
    {
      "name": "Best Bus Daund to Grishneshwar",
      "description": "Best Bus Daund to Grishneshwar guarantees top-quality buses, punctual service, and professional drivers. Perfect for group pilgrimages, family trips, and religious tours, ensuring a safe and enjoyable journey."
    },
    {
      "name": "Pilgrimage Bus Rental",
      "description": "Pilgrimage Bus Rental offers dedicated transport for religious trips and temple visits, including Grishneshwar. Reliable buses, skilled drivers, and organized itineraries ensure a convenient, safe, and memorable spiritual journey."
    },
    {
      "name": "Tourist Bus Grishneshwar",
      "description": "Tourist Bus Grishneshwar caters to sightseeing and short trips to Grishneshwar and nearby attractions. Comfortable seating, flexible schedules, and professional drivers make it ideal for tourists and family travelers."
    },
    {
      "name": "Online Bus Booking Daund",
      "description": "Online Bus Booking Daund allows easy reservation of buses from Daund to Grishneshwar. Instant confirmation, multiple bus options, and flexible itineraries simplify planning for family trips, group tours, and religious journeys."
    },
    {
      "name": "Temple Darshan Bus",
      "description": "Temple Darshan Bus provides organized transportation for visiting Grishneshwar and other nearby temples. Spacious buses, safety measures, and professional drivers ensure a smooth and memorable pilgrimage experience."
    },
    {
      "name": "Daund Travel Bus",
      "description": "Daund Travel Bus offers reliable transport solutions for local, outstation, and religious travel. Combining comfort, safety, and affordability, it caters to families, corporate groups, tourists, and pilgrims traveling to Grishneshwar."
    },
    {
      "name": "Jyotirlinga Tour Bus",
      "description": "Jyotirlinga Tour Bus is specially designed for devotees visiting the twelve Jyotirlinga temples, including Grishneshwar. Comfortable buses, professional drivers, and organized itineraries ensure a seamless and enriching spiritual journey."
    }
  ],
  "tableData": [
    ["Daund to Grishneshwar Bus On Rent", "Grishneshwar Jyotirlinga Bus"],
    ["AC Bus Daund to Grishneshwar", "Religious Bus Tour Daund"],
    ["Family Bus Grishneshwar", "Group Travel Bus Grishneshwar"],
    ["Affordable Bus Grishneshwar", "Chauffeur Driven Bus Grishneshwar"],
    ["Best Bus Daund to Grishneshwar", "Pilgrimage Bus Rental"],
    ["Tourist Bus Grishneshwar", "Online Bus Booking Daund"],
    ["Temple Darshan Bus", "Daund Travel Bus"],
    ["Jyotirlinga Tour Bus", "—"]
  ]
,



"whychoose": [
  {
    "WhyChooseheading": "Daund to Trimbakeshwar Bus on Rent with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable bus rental services from Daund to Trimbakeshwar, ideal for pilgrimages, group outings, corporate trips, and family tours."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses",
    "WhyChoosedescription": "Our buses are clean, air-conditioned, and regularly serviced, ensuring a smooth and comfortable journey for your group from Daund to Trimbakeshwar."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are familiar with the Daund to Trimbakeshwar route, ensuring safe, timely, and smooth travel for your group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for Daund to Trimbakeshwar bus rentals, including fuel, tolls, and driver allowances, with no hidden charges."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available around the clock to assist with bookings, travel queries, and itinerary planning for your Daund to Trimbakeshwar bus rental."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Choose from hourly, half-day, full-day, or customized rental packages based on your group’s schedule and travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience for your group."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Daund to Trimbakeshwar bus rentals."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services from Daund to Trimbakeshwar?',
    answer: 'Yes, Sanavi Travels offers reliable bus rental services for travel from Daund to Trimbakeshwar for pilgrimages, family tours, and group outings.'
  },
  {
    question: 'How can I book a bus from Daund to Trimbakeshwar?',
    answer: 'You can easily book a bus through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for rental from Daund to Trimbakeshwar?',
    answer: 'Sanavi Travels provides a variety of buses including mini buses, 20-seater, 32-seater, 45-seater, and 50-seater options for your journey from Daund to Trimbakeshwar.'
  },
  {
    question: 'Are the drivers experienced with the Daund to Trimbakeshwar route?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the Daund to Trimbakeshwar route, ensuring safe and timely travel.'
  },
  {
    question: 'Can I choose custom pickup and drop-off locations?',
    answer: 'Absolutely. You can select your preferred pickup location in Daund and drop-off in Trimbakeshwar.'
  },
  {
    question: 'Is the bus service from Daund to Trimbakeshwar available 24x7?',
    answer: 'Yes, Sanavi Travels provides round-the-clock bus services from Daund to Trimbakeshwar to accommodate your travel schedule.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized before departure to ensure a safe and hygienic experience for your group.'
  },
  {
    question: 'What payment options are available for bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for your bus rental bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Daund to Trimbakeshwar bus trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Manoj Patil',
    feedback: 'Rented a bus for our pilgrimage trip from Daund to Trimbakeshwar. Comfortable ride, professional driver, and excellent service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Aarti Kulkarni',
    feedback: 'Sanavi Travels made our Daund to Trimbakeshwar journey smooth and stress-free. Highly recommend their bus rental service.',
    rating: 5
  }
];




































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Daund to Grishneshwar Bus On Rent - Sanavi Travels",
  "description": "Sanavi Travels provides AC and luxury buses on rent from Daund to Grishneshwar for family trips, group tours, and religious Jyotirlinga pilgrimages. Affordable chauffeur-driven buses with easy online booking.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "55"
  }
};






  return (
    <div>
<Helmet>
  <title>
    Daund to Grishneshwar Bus On Rent | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Sanavi Travels provides AC and luxury buses on rent from Daund to Grishneshwar for family trips, group tours, and religious Jyotirlinga pilgrimages. Affordable chauffeur-driven buses with easy online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/123.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Daundtogrishneshwarbusonrent;